import {ofType} from "redux-observable-es6-compat";
import {IAppTypeMap, Ic, IDesignSolution} from "../../models/common";
import {Injectable} from "@angular/core";
import {
  TOPOLOGY_BOOST,
  TOPOLOGY_BUCK_BOOST, TOPOLOGY_BUCK, TOPOLOGY_FLYBACK, TOPOLOGY_HPF_QR_FLYBACK, TOPOLOGY_INVERTING_BUCK_BOOST,
  TOPOLOGY_ISOLATED_FLYBACK,
  TOPOLOGY_NON_ISOLATED_FLYBACK, TOPOLOGY_PFC_BOOST,
  TOPOLOGY_POSITIVE_BUCK_BOOST, TOPOLOGY_QR_FLYBACK, TOPOLOGY_FLOATING_BOOST, getResourceImagePath
} from "../../models/view";
import {ApplicationTestActions} from "../Actions/application-tests-actions";
import {Utils} from "../../common/utils";
import {isNull, isNullOrUndefined} from "util";
import {select} from "@angular-redux/store";
import {XmlUtils} from "../../common/xmlUtils";
import {IeDsFileSystem} from "../../models/user-info";
import {HttpClient} from "@angular/common/http";
import {of} from "rxjs";
import {mergeMap} from "rxjs/operators";

/**
 * Created by claudio iozzia on 14/06/2017.
 */

@Injectable()
export class TestsEpics {
  private topologies = [
    TOPOLOGY_QR_FLYBACK,
    TOPOLOGY_HPF_QR_FLYBACK,
    TOPOLOGY_PFC_BOOST,
    TOPOLOGY_FLYBACK,
    TOPOLOGY_ISOLATED_FLYBACK,
    TOPOLOGY_NON_ISOLATED_FLYBACK,
    TOPOLOGY_BOOST,
    TOPOLOGY_FLOATING_BOOST,
    TOPOLOGY_BUCK_BOOST,
    TOPOLOGY_POSITIVE_BUCK_BOOST,
    TOPOLOGY_INVERTING_BUCK_BOOST,
    TOPOLOGY_BUCK,
  ];

  constructor(private http: HttpClient) {
    this.appTypeMap$.subscribe((x) => this._appType = x);
  }

  _appType: IAppTypeMap;

  @select(state => state.appProjectTypes.appTypeMap) appTypeMap$;

  private testFileExist(ic: IDesignSolution, file: string) {
    this.http.get(file)
      // .catch((err:string, c:Observable<Response>) => console.log("Load error", err))
      .subscribe((y) => {
      }, (err) => {
        console.log("File missed:", file, " ic:", ic.key);
      }, () => {
      });
  }

  private test_CatalogKey(catalog: Ic[]) {
    const temp = catalog.concat().sort((a, b) => a.key.localeCompare(b.key)).filter((x, i, arr) => i > 0 ? x.key === arr[i - 1].key : false);
    if (temp.length > 0) {
      console.log("Key duplicated for", temp);
    }

    catalog.forEach((x) => {

      // this.testFileExist(x, getResourceImagePath('xs', x.schematic));
      // this.testFileExist(x, getResourceImagePath('sm', x.schematic));
      // this.testFileExist(x, getResourceImagePath('md', x.schematic));
      // this.testFileExist(x, getResourceImagePath('lg', x.schematic));
      // this.testFileExist(x, getResourceImagePath('xl', x.schematic));
      // this.testFileExist(x, getResourceImagePath('xs', x.packageImage));
      // this.testFileExist(x, getResourceImagePath('sm', x.packageImage));
      // this.testFileExist(x, getResourceImagePath('md', x.packageImage));
      // this.testFileExist(x, getResourceImagePath('lg', x.packageImage));
      // this.testFileExist(x, getResourceImagePath('xl', x.packageImage));
//      this.testFileExist(x, x.datasheet);
      this.test_Topologies(x);
      this.test_validatorPowerMax(x);
      this.testDesignDataAppTypeName(x);
    });
    this.testXmlToJson();

    // const toZip = JSON.stringify(catalog);
    // const encode = Utils.lzw_encode(toZip);
    // //console.log("lzw encode catalog", toZip.length, encode.length, encode );
    // const decode = Utils.lzw_decode(encode);
    // console.log("lzw sizes ", toZip.length, encode.length, decode.length);
    // for (let i = 0; i < toZip.length; i++) {
    //   if (toZip.charAt(i) !== decode.charAt(i))
    //     console.log("lzw decode catalog fail at ", i);
    // }
    //
    // const toenc = '%%app te%st 4Ω ╪╓3'
    // const encode2 = Utils.lzw_encode(toenc);
    // const decode2 = Utils.lzw_decode(encode2);
    // console.log("Test2", encode2.length, encode2, decode2.length, toenc===decode2, decode2);
  }

  // Todo check topologies
  private test_Topologies(ic: IDesignSolution) {
    if (!this.topologies.includes(ic.topology.toLowerCase())) {
      console.log("Topology non exist", ic.topology);
    }
  }

  private test_validatorPowerMax(ic: Ic) {
    const maxPower: number = Utils.getFieldValue(ic, "validator.power.max", null);

    if (isNull(maxPower)) {
      console.log("Missed validator.power.max in ", ic.CPN, ic.topology);
    }
  }

  private testDesignDataAppTypeName(ic: Ic) {
    const appTypeName: string = Utils.getFieldValue(ic, "designData.appName", null);

    if (isNull(appTypeName)) {
      console.log("Missed designData.appName in ", ic.CPN, ic.topology);
    } else {
      if (isNullOrUndefined(this._appType.apps.find(x => x.app.name === appTypeName))) {
        console.log("Wrong designData.appName in ", ic.CPN, ic.topology);
      }
    }
  }

  private testXmlToJson() {
    const user = '<item\n' +
      '  label="Welcome, Iozzia.Claudio"\n' +
      '  bold="true"\n' +
      '  who="Iozzia.Claudio"\n' +
      '  mail="NaN"\n' +
      '>\n' +
      '</item>';

    of(user).pipe(XmlUtils.toJSON).subscribe((val) => console.log("XML Conversion ", val), (err) => console.log("XML Error ", err));

    XmlUtils.loadXmlFile(this.http, 'assets/temp/user.xml').subscribe((val) => console.log("User ", val), (err) => console.log("Load USER Error ", err));
    XmlUtils.loadXmlFile(this.http, 'assets/temp/user-files.xml').subscribe((val) => {
      const test: IeDsFileSystem = val;
      console.log("User files ", test);
    }, (err) => console.log("Load User file Error ", err));
    XmlUtils.loadXmlFile(this.http, 'assets/temp/list.xml').subscribe((val) => {
      const test: IeDsFileSystem = val;
      console.log("Examples ", test);
    }, (err) => console.log("Load Demo Examples Error ", err));
    // XmlUtils.loadXmlFile(this.http,'assets/temp/ic_acdc_catalogs.xml').subscribe((val)=>console.log("Load DB ", val), (err)=>console.log("Load Error ", err));
  }

  testCatalog = (action$, store) => {
    return action$.pipe(
      ofType(ApplicationTestActions.ActionType.TEST_CATALOG),
      mergeMap(() => {
        this.test_CatalogKey(store.value.appCatalog.db);
        return of(ApplicationTestActions.testCompleted());
      })
    );
  }
}
